import { render } from "./qualification.vue?vue&type=template&id=0fd2bfcd"
import script from "./qualification.vue?vue&type=script&lang=js"
export * from "./qualification.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__